import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const SUPPLIER_EXCHANGE_RATES_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('SUPPLIER_EXCHANGE_RATES');
export const SUPPLIER_EXCHANGE_RATES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	SUPPLIER_EXCHANGE_RATES_CRUD_ACTION_CONSTANTS
);
